import { useEffect, useRef, useState } from "react";
import { useRootStore } from "../hooks/useRootStore";
import { Box, Button, Card, Checkbox, Divider, Link } from "@mui/material";
import type { Project } from "../data/Project";
import './Project.css'
import { UserType } from "../data/UserType";
import { EmployeeProfile } from "../data/UserProfile";
import { EmployeeAccessLevel } from "../data/EmployeeAccessLevel";
import { MDXEditor, MDXEditorMethods } from '@mdxeditor/editor';
import { MdxPlugins } from './MarkdownEditor/MarkdownEditorPlugins';
import MarkdownView from "./MarkdownView";

export default function Project() {
    const { api, routerStore, userProfile } = useRootStore();
    const id = routerStore.routerState.params.id as unknown as number;

    const [loading, setLoading] = useState(true);
    const [project, setProject] = useState({} as Project);

    const [asideTop, setAsideTop] = useState(0);
    const [appStateHeight, setAppStateHeight] = useState(0);

    useEffect(() => {
        setAsideTop((document.getElementsByTagName('header')[0]).offsetHeight + 2);
        setAppStateHeight((document.getElementsByClassName('app-state')[0] as HTMLElement).offsetHeight);
    }, []);

    useEffect(() => {
        api.getProject(id).then(e => {
            setProject(e!);
            setLoading(false);
        });

    }, [id, api]);

    const mdxEditorRef = useRef<MDXEditorMethods>(null);

    const saveAccessRules = async () => {
        await api.updateProjectAccessRules(id, mdxEditorRef.current?.getMarkdown() ?? '');
    }

    return (
        loading ? 'Загрузка' :
            <Box className='project'>
                <Box style={{ top: asideTop, height: 'calc(100vh - ' + (asideTop + appStateHeight + 20) + 'px)' }} className="project-aside" id="project-aside">
                    <Box className='project-intro'>
                        <Box className='project-name'>{project.Name}</Box>
                    </Box>
                    <Box sx={{ textAlign: 'left' }}>
                        <Card>
                            <Box>Клиент: <Link href={`clients/${project.ClientID}`}>{project.ClientName}</Link></Box>
                            <Box>Куратор: {project.ResponsibleEmployee ? <Link href={`employees/${project.ResponsibleEmployee.ID}`}>{project.ResponsibleEmployee.Name}</Link> : ''}</Box>
                            <Box>Архивный: <Checkbox sx={{ p: 0 }} disabled checked={project.Archivated} /></Box>
                            <Box>Автораспределение задач: <Checkbox sx={{ p: 0 }} disabled checked={!project.NoQueueScheduler} /></Box>
                            <Box>Бонус за предпочтение: <Checkbox sx={{ p: 0 }} disabled checked={!project.NoPreferredBonus} /></Box>
                        </Card>
                    </Box>
                </Box>
                <Divider orientation="vertical" flexItem />
                <Box flex={1} sx={{ p: 2, textAlign:'left' }}>
                    <h2 className='project-name'>{project.Name}</h2>
                    {userProfile?.UserType != UserType.Employee ? '' :
                        (userProfile as EmployeeProfile).AccessLevelID == EmployeeAccessLevel.fullAccess ?
                            <>
                                <Box sx={{ mt: 0.5, textAlign: 'left', minHeight: '300px', border: '1px solid #cccccc', borderRadius: 1 }} onClick={() => mdxEditorRef.current?.focus()}>
                                    <MDXEditor
                                        ref={mdxEditorRef}
                                        markdown={project.AccessRules ?? ''}
                                        plugins={MdxPlugins.standardPlugins(api)}
                                    />
                                </Box>
                                <Button onClick={saveAccessRules}>Сохранить</Button>
                            </>
                            :
                            <Box>
                                <MarkdownView markup={project.AccessRules ?? ''} />
                            </Box>
                    }
                </Box>
            </Box>
    );
}